/**
 * Created by spepa on 03.09.2024
 */

const PassPackBadge = cc.Node.extend({
    ctor: function (offer) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        const badge = new cc.Sprite(cleverapps.skins.getSlot("pass_badge_png") || bundles.passheader.frames.pass_badge_png);
        this.setContentSize(badge.getContentSize());
        this.addChild(badge);
        badge.setAlignment(this.width / 2, this.height / 2);

        const styles = cleverapps.styles.PassPackBadge[offer.type] || cleverapps.styles.PassPackBadge;
        const price = new TextWithIcon(offer.logic.getPriceText(), { font: cleverapps.styles.FONTS.BUTTON_BROWN_TEXT || cleverapps.styles.FONTS.BUTTON_TEXT });
        badge.addChild(price);
        price.fitTo(styles.text.width);
        price.setRotation(styles.text.rotation);
        price.setAlignment(styles.text);
    }
});

cleverapps.styles.PassPackBadgeTemplate = {
    text: {
        x: { align: "center", dx: 37 },
        y: { align: "center", dy: 13 },
        rotation: -17,
        width: 130
    }
};

cleverapps.styles.PassPackBadge = cleverapps.overrideStyles(cleverapps.styles.PassPackBadgeTemplate, {}, true);
